import React from 'react';

export class Item extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  }
        this.createStyles = this.createStyles.bind(this);
    }

    createStyles() {
        const p = this.props;
        return { width: p.width, height: p.height }
    }

    render() { 
        const p = this.props;
        let styles = this.createStyles();
        return (
            <div 
                className={ `marketkit-skeleton-item${p.className ? ` ${p.className}` : ''}` }
                style={ styles }
            ></div>
        );
    }
}

export default Item;

